var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-4076 -14536)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    transform: "translate(4076 14536)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(4079.459 14539.459)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-495.151-585.335a14.709,14.709,0,0,0-14.582,14.551,14.714,14.714,0,0,0,14.5,14.53,14.709,14.709,0,0,0,14.582-14.551A14.714,14.714,0,0,0-495.151-585.335Zm.007,27.209a12.8,12.8,0,0,1-12.717-12.7,12.8,12.8,0,0,1,12.673-12.639,12.8,12.8,0,0,1,12.665,12.647A12.811,12.811,0,0,1-495.144-558.126Z",
    transform: "translate(509.733 585.335)",
    fill: "#707070",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-444.919-552.874c0-1.453.012-2.906-.005-4.359-.009-.713.257-1.111,1.016-1.126.8-.016,1.11.364,1.1,1.143-.018,2.422.013,4.844-.02,7.265a1.419,1.419,0,0,0,.7,1.365c1.036.686,2.03,1.436,3.029,2.177.578.428.961.929.409,1.652-.539.7-1.076.67-1.759.136-1.252-.978-2.546-1.9-3.856-2.8a1.272,1.272,0,0,1-.626-1.2C-444.9-550.036-444.919-551.455-444.919-552.874Z",
    transform: "translate(458.406 563.969)",
    fill: "#58beb3",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.3c56f2a1.svg";
export { ForwardRef as ReactComponent };